let GAHelper = {};

GAHelper.install = function (Vue) {
  Vue.send = (params) => {
    if (!env.isProduction) {
      return;
    }
    window.ga(...params);
  };
};

export default GAHelper;
